import { type Location, createPath, parsePath } from "react-router";

import { caseConf, caseConfs } from "../conf";

const caseDetailPath =
  /^\/case\/(?:detail\/[^/]+(?:\/|$)|[^/]+\/proceeding-proposal(?:\/|$))/;

export function getCaseReturnUrl(search: string) {
  return (
    new URLSearchParams(search).get("returnTo") ?? caseConf.getListUrl("all")
  );
}

export function withCaseReturnTo(url: string, returnTo: string | null) {
  // Přímé odkazy bez návratové cesty zůstávají beze změny.
  if (returnTo === null) {
    return url;
  }

  const path = parsePath(url);
  const searchParams = new URLSearchParams(path.search);
  searchParams.set("returnTo", returnTo);

  return createPath({ ...path, search: `?${searchParams}` });
}

export function preserveCaseReturnTo(
  url: string,
  location: Pick<Location, "pathname" | "search">,
) {
  const target = parsePath(url);

  // Kontext seznamu se přenáší pouze do případových detailů, explicitní cíl má přednost.
  if (
    !caseDetailPath.test(target.pathname ?? "") ||
    new URLSearchParams(target.search).has("returnTo")
  ) {
    return url;
  }

  const fromList = Object.values(caseConfs).some(
    (conf) => conf.url === location.pathname,
  );
  const returnTo = fromList
    ? `${location.pathname}${location.search}`
    : caseDetailPath.test(location.pathname)
      ? new URLSearchParams(location.search).get("returnTo")
      : null;

  return withCaseReturnTo(url, returnTo);
}
